import React from "react";
import DeleteAccountFlow from "../Components/DeleteAccountFlow";

const Login = () => {
  return <DeleteAccountFlow variant="login" />;
};

export default Login;
